import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_187_bill_allocations: any[] = [
  {
    "componentType": "screenGroup",
    "fabAction": {
      "type": "add",
      "screenId": "188",
      "action": "navigate_modulev1/bill_allocations"
    },
    "title": "Bill wise allocations",
    "style": {
      "backgroundColor": "#F9FAFB"
    },
    "childComponents": [
      {
        "componentType": "group",
        "style": {
          "backgroundColor": "#ffffff",
          "direction": "column",
          "borderRadius": 12,
          "padding": 16
        },
        "childComponents": [
          {
            "componentType": "summeryList",
            "titleValue": "name",
            "Name": "receivables_summary",
            "BindValue": "grid_purchase",
            "Form": {
              "Name": "receivables_summary",
              "TableName": "",
              "View": "view_bill_allocation_list",
              "DisplayName": "receivables_summary",
              "Fields": [
                {
                  "IncludeLabel": true,
                  "Label": "id",
                  "BindValue": "id",
                  "Json_Attribute": "id",
                  "componentType": "textField",
                  "showInSummary": false,
                  "IsPrimary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Customer name",
                  "BindValue": "name",
                  "Json_Attribute": "name",
                  "componentType": "textField",
                  "showInSummary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Customer address",
                  "BindValue": "address",
                  "Json_Attribute": "address",
                  "componentType": "textField",
                  "showInSummary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Allocated amount",
                  "BindValue": "amount",
                  "Json_Attribute": "amount",
                  "componentType": "textField",
                  "showInSummary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Remarks",
                  "BindValue": "remarks",
                  "Json_Attribute": "remarks",
                  "componentType": "textField",
                  "showInSummary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Created by",
                  "BindValue": "created_by",
                  "Json_Attribute": "created_by",
                  "componentType": "textField",
                  "showInSummary": true
                },
                {
                  "IncludeLabel": true,
                  "Label": "Created at",
                  "BindValue": "created_at",
                  "Json_Attribute": "created_at",
                  "componentType": "dateField",
                  "showInSummary": true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];
